

















































































































































































































































import emoji from 'emoji-regex';
import { computed, defineComponent, reactive, ref, PropType } from '@vue/composition-api';
import { i18n } from '@tt4b/ttam-i18n';
import { bytesToSize, stringLength, getFileNameAndExtension } from '@tt4b/ttam-utils';
import { FileUploadStatus, MaterialType, VideoToUpload } from '@tt4b/ttam-enums';
import { useCheckNameExistServiceApi } from '@tt4b/ttam-hooks';
import AdaptiveListContainer from '@/components/common/adaptive-list-container/index.vue';

/**
 * 校验素材名称
 * @param {string} name 校验目标
 * @param {string[]} otherNames 其他已有的名称
 * @returns {string | null} 校验结果
 */
async function validateName(name, config: { otherNames?: string[]; type?: MaterialType }) {
  const { otherNames = [], type = MaterialType.Video } = config;
  const MinLength = 1;
  const MaxLength = 100;
  const len = stringLength(name);
  if (!(len >= MinLength && len <= MaxLength)) {
    return i18n.t('module_library_filename_length_hint');
  }

  /** 检查是否含有 emoji */
  const hasEmoji = emoji().test(name);
  if (hasEmoji) {
    return i18n.t('module_library_filename_emoji_hint');
  }

  /** 本地检查是否重名 */
  if (otherNames && otherNames.includes(name)) {
    return i18n.t('module_library_filename_duplicate_hint');
  }

  /** 接口检查是否重名 */
  const res = await useCheckNameExistServiceApi([name], type);
  if (res && res[name]) {
    return i18n.t('module_library_filename_duplicate_hint');
  }

  return null;
}

const name = 'ttam-material-image-upload-select-table';
export default defineComponent({
  name,
  components: { AdaptiveListContainer },
  props: {
    files: { type: Array as PropType<VideoToUpload[]>, default: () => [] },
    fileType: { type: String as PropType<MaterialType>, default: MaterialType.Video },
    inventoryCheck: { type: Boolean, default: () => true },
  },

  setup(props, ctx) {
    /** 记录当前修改名字的项 */
    let fileToChangeName;

    const tableNode = ref();
    const selectedItems = ref([]);
    const nameToChanged = reactive({ name: '', extension: '' });
    const nameChangeError = ref('');
    const nameChanging = ref(false);

    const fileUploadStatus = computed(() => FileUploadStatus);

    /** 选中所有可选的视频 */
    function selectAll() {
      props.files.forEach(row => tableNode.value.toggleRowSelection(row, row.status === FileUploadStatus.Ready));
    }

    /** 选中事件 */
    function onSelectChange(val) {
      selectedItems.value = val;
      ctx.emit('onSelect', selectedItems.value);
    }

    /** 修改名字 */
    function changeName(material) {
      fileToChangeName = material;
      const { extension, excludeExtName } = getFileNameAndExtension(material.name);
      nameToChanged.name = excludeExtName;
      nameToChanged.extension = extension;
    }

    const errorMessageList = verify => {
      const result = [] as Array<any>;
      verify?.forEach(item => {
        item?.message?.forEach(messageItem => {
          result.push(`${item.label}: ${messageItem}`);
        });
      });

      return result ?? [];
    };

    /** 关闭修改 name 的 popover */
    function onCancelNameChange() {
      document.body.click();
    }

    /** 确认修改 name */
    function onConfirmNameChange(material) {
      nameChanging.value = true;
      const fullNameChanged = `${nameToChanged.name}${nameToChanged.extension}`;
      const otherNames = props.files.filter(file => file !== fileToChangeName).map(i => i.name);

      validateName(fullNameChanged, { otherNames, type: props.fileType }).then(error => {
        nameChanging.value = false;
        if (error) {
          nameChangeError.value = error as string;

          return;
        }
        nameChangeError.value = '';
        material.name = `${nameToChanged.name}${nameToChanged.extension}`;
        material.raw = new window.File([material.raw], material.name, { type: material.raw.type });
        onCancelNameChange();
        if (material.status === FileUploadStatus.NameDuplicate) {
          material.status = FileUploadStatus.Ready;
          material.disabled = false;
          // 修改名称后，将可选中的上传文件，自动选中
          selectAll();
        }
      });
    }

    function backCrop() {
      ctx.emit('backCrop');
    }

    function formatSize(item) {
      return bytesToSize(item.size ?? 0);
    }

    return {
      name,
      tableNode,
      nameToChanged,
      nameChangeError,
      nameChanging,
      selectedItems,
      errorMessageList,
      fileUploadStatus,

      selectAll,
      formatSize,
      changeName,
      onCancelNameChange,
      onConfirmNameChange,
      onSelectChange,
      backCrop,
    };
  },
});
